// extracted by mini-css-extract-plugin
export default {"container":"SkillList_container__uhmfz","icon":"SkillList_icon__MmcAp","skill":"SkillList_skill__exzal"};